/**
 * Pure selection of the effective default ("startup") database id. No
 * `vue`/`ref`/IO — the shell resolves the user's preferred id and passes it in.
 */

export interface DatabaseLike {
  readonly id: string
  readonly isDefault: boolean
}

/**
 * Pick the startup database id: the user's preferred id when it still maps to
 * an accessible database, else the backend default, else the first database,
 * else an empty string.
 */
export function selectDefaultDatabaseId(
  databases: readonly DatabaseLike[],
  preferredId: string
): string {
  if (preferredId && databases.some((db) => db.id === preferredId)) {
    return preferredId
  }
  const backendDefault = databases.find((db) => db.isDefault)
  if (backendDefault) return backendDefault.id
  return databases[0]?.id ?? ''
}
